/**
 * Cart savings – Control / V1 / V2
 * Three "You saved … today" rows on cart page and Rebuy drawer.
 * Control: ≤ $50 → %, over → $.
 * V1:      ≤ $75 → %, over → $.
 * V2:      ≤ $100 → %, over → $.
 * Theme setting adds body class cart-savings-variant-*; CSS shows that row.
 * Intellijems can still override visibility with CSS.
 */
(function () {
  'use strict';

  var moneyFormat = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '${{amount}}';

  var CART_SAVINGS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M6 0C2.69146 0 0 2.69146 0 6C0 9.30854 2.69146 12 6 12C9.30854 12 12 9.30854 12 6C12 2.69146 9.30854 0 6 0ZM9.84755 4.76352L5.46355 9.14752C5.31255 9.29852 5.11155 9.38152 4.89805 9.38152C4.68454 9.38152 4.48355 9.29852 4.33254 9.14752L2.35251 7.16749C2.20151 7.01649 2.11852 6.81549 2.11852 6.60198C2.11852 6.38848 2.20152 6.18748 2.35251 6.03648C2.50351 5.88498 2.70451 5.80198 2.91802 5.80198C3.13152 5.80198 3.33252 5.88548 3.48352 6.03648L4.89805 7.45101L8.71654 3.63251C9.01855 3.33051 9.54555 3.33051 9.84754 3.63251C9.99904 3.78401 10.082 3.98451 10.082 4.19802C10.082 4.41152 9.99905 4.61202 9.84755 4.76352Z" fill="#FF4701"/></svg>';

  var VARIANTS = [
    { key: 'control', thresholdCents: 5000, cartAttr: 'data-cart-savings-control', rebuyAttr: 'data-rebuy-savings-control', className: 'cart__savings-compare--control' },
    { key: 'v1', thresholdCents: 7500, cartAttr: 'data-cart-savings-v1', rebuyAttr: 'data-rebuy-savings-v1', className: 'cart__savings-compare--v1' },
    { key: 'v2', thresholdCents: 10000, cartAttr: 'data-cart-savings-v2', rebuyAttr: 'data-rebuy-savings-v2', className: 'cart__savings-compare--v2' }
  ];

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '$0.00';
    var amount = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function parseMoneyText(text) {
    if (!text || typeof text !== 'string') return 0;
    var num = parseFloat(text.replace(/[^0-9.]/g, '')) || 0;
    return Math.round(num * 100);
  }

  
  function getCompareCents(compareEl) {
    if (!compareEl || compareEl.classList.contains('hide')) return 0;
    var text = (compareEl.textContent || '').trim();
    if (!text) return 0;
    return parseMoneyText(text);
  }

  function percentValue(savingsCents, compareCents) {
    if (!compareCents || compareCents <= 0 || savingsCents <= 0) return 0;
    return Math.round((savingsCents / compareCents) * 100);
  }

  function formatPercent(savingsCents, compareCents) {
    if (!compareCents || compareCents <= 0 || savingsCents <= 0) return '0%';
    return percentValue(savingsCents, compareCents) + '%';
  }

  function savingsDisplayText(savingsCents, compareCents, totalCents, thresholdCents) {
    if (totalCents <= thresholdCents) {
      return formatPercent(savingsCents, compareCents);
    }
    return formatMoney(savingsCents);
  }

  function savingsRowInner(displayText) {
    return '<span class="cart__savings-compare-check cart__savings-compare-check--icon" aria-hidden="true">' + CART_SAVINGS_SVG + '</span>' +
      '<span class="cart__savings-compare-text">Congrats! You saved <strong class="cart__savings-compare-amount" data-savings-display>' + displayText + '</strong> today.</span>';
  }

  /** Remove leftover rows from older single-variant implementations. */
  function removeLegacyBlocks() {
    document.querySelectorAll(
      '[data-cart-savings-compare], [data-cart-savings-compare-percent], [data-rebuy-savings], [data-rebuy-savings-percent]'
    ).forEach(function (el) {
      el.remove();
    });
  }

  function removeAllCartPageVariantBlocks() {
    VARIANTS.forEach(function (v) {
      var el = document.querySelector('[' + v.cartAttr + ']');
      if (el) el.remove();
    });
  }

  function upsertCartPageVariant(variant, savingsCents, compareCents, totalCents, insertAfter) {
    var existing = document.querySelector('[' + variant.cartAttr + ']');
    var displayText = savingsDisplayText(savingsCents, compareCents, totalCents, variant.thresholdCents);

    if (existing) {
      var span = existing.querySelector('[data-savings-display]');
      if (span) span.textContent = displayText;
      existing.setAttribute('data-compare-at', compareCents);
      existing.setAttribute('data-total', totalCents || '');
      return existing;
    }

    if (!insertAfter) return null;
    var block = document.createElement('div');
    block.className = 'cart__item-row cart__savings-compare ' + variant.className;
    block.setAttribute(variant.cartAttr, '');
    block.setAttribute('data-compare-at', compareCents);
    block.setAttribute('data-total', totalCents || '');
    block.innerHTML = savingsRowInner(displayText);
    insertAfter.insertAdjacentElement('afterend', block);
    return block;
  }

  function updateCartPageSavingsBlocks(savingsCents, compareCents, totalCents) {
    if (savingsCents <= 0) {
      removeAllCartPageVariantBlocks();
      return;
    }

    var after = document.querySelector('.cart__footer [data-savings]');
    if (!after) return;

    /* Insert in reverse so final DOM order is control → v1 → v2 */
    var insertAfter = after;
    for (var i = 0; i < VARIANTS.length; i++) {
      var block = upsertCartPageVariant(VARIANTS[i], savingsCents, compareCents, totalCents, insertAfter);
      if (block) insertAfter = block;
    }
  }

  function getCartItemCount() {
    var form = document.querySelector('#CartPageForm');
    if (!form) return 0;
    var productsEl = form.querySelector('[data-products]');
    if (!productsEl) return 0;
    var cartItemsEl = productsEl.querySelector('.cart__items');
    if (cartItemsEl && cartItemsEl.getAttribute('data-count') !== null) {
      return parseInt(cartItemsEl.getAttribute('data-count'), 10) || 0;
    }
    return (productsEl.querySelectorAll('.cart__item').length) || 0;
  }

  function updateCartPageSubtotalLabel() {
    var form = document.querySelector('#CartPageForm');
    if (!form) return;
    var subEl = form.querySelector('.cart__footer .cart__subtotal');
    if (!subEl) return;
    var count = getCartItemCount();
    subEl.textContent = count === 1 ? 'Subtotal (1 item)' : 'Subtotal (' + count + ' items)';
  }

  function updateCartPageSavingsFromFooter() {
    removeLegacyBlocks();
    updateCartPageSubtotalLabel();
    var subEl = document.querySelector('.cart__footer [data-subtotal]');
    var compareEl = document.querySelector('.cart__footer [data-cart-compare-at]');
    if (!subEl) return;

    var totalCents = parseMoneyText(subEl.textContent || '');
    var compareCents = getCompareCents(compareEl);
    var savings = Math.max(0, compareCents - totalCents);

    if (savings <= 0) {
      removeAllCartPageVariantBlocks();
      document.dispatchEvent(new CustomEvent('theme:cart:savings-updated', { detail: { savings: 0 } }));
      return;
    }

    updateCartPageSavingsBlocks(savings, compareCents, totalCents);
    document.dispatchEvent(new CustomEvent('theme:cart:savings-updated', { detail: { savings: savings } }));
  }

  function removeAllRebuyVariantBlocks(container) {
    if (!container) return;
    VARIANTS.forEach(function (v) {
      var el = container.querySelector('[' + v.rebuyAttr + ']');
      if (el) el.remove();
    });
  }

  function upsertRebuyVariant(variant, savingsCents, compareCents, totalCents, insertAfter) {
    var container = insertAfter.parentElement;
    var existing = container ? container.querySelector('[' + variant.rebuyAttr + ']') : null;
    var displayText = savingsDisplayText(savingsCents, compareCents, totalCents, variant.thresholdCents);

    if (existing) {
      var span = existing.querySelector('[data-savings-display]');
      if (span) span.textContent = displayText;
      return existing;
    }

    var div = document.createElement('div');
    div.className = 'cart__item-row cart__savings-compare ' + variant.className;
    div.setAttribute(variant.rebuyAttr, '');
    div.innerHTML = savingsRowInner(displayText);
    insertAfter.insertAdjacentElement('afterend', div);
    return div;
  }

  function updateRebuyDrawerSavings() {
    removeLegacyBlocks();

    var subtotalEl = document.querySelector('.rebuy-cart__flyout-subtotal');
    var container = subtotalEl ? subtotalEl.parentElement : null;

    if (!subtotalEl) {
      removeAllRebuyVariantBlocks(container);
      return;
    }

    var finalBlock = document.querySelector('.rebuy-cart__flyout-subtotal-final-amount');
    var compareBlock = document.querySelector('.rebuy-cart__flyout-subtotal-compare-amount');
    var finalCents = finalBlock ? parseMoneyText(finalBlock.textContent || '') : 0;
    var compareCents = compareBlock ? parseMoneyText(compareBlock.textContent || '') : 0;
    var savings = (finalBlock && compareBlock) ? Math.max(0, compareCents - finalCents) : 0;

    if (savings <= 0) {
      removeAllRebuyVariantBlocks(container);
      return;
    }

    var insertAfter = subtotalEl;
    for (var i = 0; i < VARIANTS.length; i++) {
      var block = upsertRebuyVariant(VARIANTS[i], savings, compareCents, finalCents, insertAfter);
      if (block) insertAfter = block;
    }
  }

  document.addEventListener('theme:cart:footer-updated', updateCartPageSavingsFromFooter);

  var rebuyObserver = null;
  var rebuySuppress = false;
  var rebuyScheduled = null;

  function runRebuyUpdate() {
    rebuyScheduled = null;
    rebuySuppress = true;
    updateRebuyDrawerSavings();
    setTimeout(function () { rebuySuppress = false; }, 0);
  }

  function scheduleRebuyUpdate(delay) {
    if (rebuyScheduled) clearTimeout(rebuyScheduled);
    rebuyScheduled = setTimeout(runRebuyUpdate, delay == null ? 60 : delay);
  }

  function isSavingsMutationTarget(t) {
    if (!t || !t.closest) return false;
    return !!(
      t.closest('[data-rebuy-savings-control]') ||
      t.closest('[data-rebuy-savings-v1]') ||
      t.closest('[data-rebuy-savings-v2]')
    );
  }

  function observeRebuyCart() {
    if (rebuyObserver) return;
    var root = document.querySelector('#rebuy-cart') || document.querySelector('.rebuy-cart__flyout');
    if (!root) return;
    rebuyObserver = new MutationObserver(function (mutations) {
      if (rebuySuppress) return;
      for (var i = 0; i < mutations.length; i++) {
        if (isSavingsMutationTarget(mutations[i].target)) continue;
        scheduleRebuyUpdate();
        return;
      }
    });
    rebuyObserver.observe(root, { childList: true, subtree: true, characterData: true });
  }

  document.addEventListener('rebuy:cart.change', function () { observeRebuyCart(); scheduleRebuyUpdate(150); });
  document.addEventListener('rebuy:smartcart.open', function () { observeRebuyCart(); scheduleRebuyUpdate(200); });
  document.addEventListener('rebuy:smartcart.ready', function () { observeRebuyCart(); scheduleRebuyUpdate(200); });
  document.addEventListener('rebuy:smartcart.didRender', function () { observeRebuyCart(); scheduleRebuyUpdate(); });

  var rebuyAttachTries = 0;
  var rebuyAttachTimer = setInterval(function () {
    rebuyAttachTries++;
    observeRebuyCart();
    if (rebuyObserver || rebuyAttachTries > 40) clearInterval(rebuyAttachTimer);
  }, 250);

  function initCartPage() {
    if (!document.querySelector('.cart__footer [data-savings]')) return;
    removeLegacyBlocks();
    updateCartPageSavingsFromFooter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCartPage();
      updateRebuyDrawerSavings();
    });
  } else {
    initCartPage();
    updateRebuyDrawerSavings();
  }
})();
